export default __webpack_public_path__ + "static/media/india.abbdca59.svg";